// extracted by mini-css-extract-plugin
export var arrow = "_37-6";
export var changeItem = "_37-3";
export var changesHeader = "_37-1";
export var changesList = "_37-2";
export var container = "_37-0";
export var pathLabel = "_37-4";
export var value = "_37-7";
export var valuesContainer = "_37-5";